//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ModalAuth',

  props: {
    visible: Boolean
  },

  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      isLoadingUserLogin: false,
      isLoadingUserLoginByGoogle: false,
      isLoadingUserLoginByYandex: false,
      isLoadingUserLoginByVK: false,
      validators: {
        username: {
          trigger: 'blur',
          validator: (rule, value, callback) => {
            const regex = /^[a-zA-Z0-9_\s]{5,20}$/

            if (this.form) {
              if (this.form.username.length === 0) {
                return callback(new Error(`Поле обязательное!`))
              }

              if (!this.form.username?.match(regex) ) {
                return callback(new Error(`Логин должен содержать от 5 до 20 символов: цифры [ 0…9 ] или латинские буквы, так же можно использовать "_" и пробел`))
              }
            }

            return callback()
          }
        },
        password: {
          trigger: 'blur',
          validator: (rule, value, callback) => {
            if (this.form) {
              if (this.form.password.length === 0) {
                return callback(new Error(`Поле обязательное!`))
              }
            }

            return callback()
          }
        },
      }
    }
  },

  methods: {
    userLogin() {
      this.$refs.ruleForm.validate((valid, errors) => {
        if (!valid) {
          const fields = {
            username: "Логин",
            password: "Пароль",
          }

          let message = []
          Object.keys(errors).map(key => {
            message.push({
              name: `${fields[key.split('.')[0]] || fields[key.split('[')[0]]}`,
              message: `${errors[key].map(x => x.message).join(',').toLowerCase()}`
            })
          })

          this.$info({
            title: "Исправьте следующие ошибки",
            content: function (h) {
              return h('div', {}, [
                message.map(item => {
                  return h('div', {}, [
                    h('strong', `${item.name}: `),
                    h('span', item.message)
                  ])
                })
              ])
            }
          })

          return
        }

        try {
          this.isLoadingUserLogin = true
          const route = this.$route.fullPath

          this.$auth.loginWith('custom', { data: this.form })
            .then(() => {
              if (this.$auth.user?.force_oauth_login) {
                const rememberUrl = this.$store.getters['auth_modals/getRememberUrl'] || route

                this.cancelAuthModal()
                this.$store.dispatch('auth_modals/rememberUrl', rememberUrl)
                this.$router.push({
                  name: 'auth-force-oauth',
                  query: { remember_url: rememberUrl }
                })
                return
              }

              this.cancelAuthModal()
              this.$router.push({ 'path': this.$store.getters['auth_modals/getRememberUrl'] || route })
              this.$message.success('Вы успешно авторизовались')
              this.$store.dispatch('auth_modals/rememberUrl', '')
            })
            .catch((err) => {
              if (err.response && err.response.status && err.response.status === 401) {
                if (err.response.data?.detail === 'USER_DISABLED_ERROR') {
                  this.cancelAuthModal()

                  this.$warning({
                    title: 'Ваш аккаунт временно заблокирован',
                    content: 'За уточнением напишите нам по адресу vs@vistat.org'
                  })
                } else {
                  this.$message.error('Логин или пароль неверные')
                }
              }
            }).finally(() => {
              this.isLoadingUserLogin = false
            })
        } catch (err) {
          this.$message.error('Что-то пошло не так')
        }
      });
    },
    userLoginByGoogle() {
      try {
        this.isLoadingUserLoginByGoogle = true
        const path = `${this.$store.state['auth_modals'].rememberUrl || this.$route.path}`
        this.$store.dispatch('auth_modals/rememberUrl', '')

        this.$auth.loginWith('google', { params: { redirect_uri: path } })
          .then(() => {
            this.cancelAuthModal()
          })
          .catch(() => {
            this.$message.error('Не получилось авторизоваться')
          }).finally(() => {
            this.isLoadingUserLoginByGoogle = false
          })
      } catch (err) {
        this.$message.error('Что-то пошло не так')
      }
    },
    userLoginByVK() {
      try {
        this.isLoadingUserLoginByVK = true
        const path = `${this.$store.state['auth_modals'].rememberUrl || this.$route.path}`
        this.$store.dispatch('auth_modals/rememberUrl', '')

        this.$auth.loginWith('vk', { params: { redirect_uri: path } })
          .then(() => {
            this.cancelAuthModal()
          })
          .catch(() => {
            this.$message.error('Не получилось авторизоваться')
          }).finally(() => {
            this.isLoadingUserLoginByVK = false
          })
      } catch (err) {
        this.$message.error('Что-то пошло не так')
      }
    },
    userLoginByYandex() {
      try {
        this.isLoadingUserLoginByYandex = true
        const path = `${this.$store.state['auth_modals'].rememberUrl || this.$route.path}`
        this.$store.dispatch('auth_modals/rememberUrl', '')

        this.$auth.loginWith('yandex', { params: { redirect_uri: path } })
          .then(() => {
            this.cancelAuthModal()
          })
          .catch(() => {
            this.$message.error('Не получилось авторизоваться')
          }).finally(() => {
            this.isLoadingUserLoginByYandex = false
          })
      } catch (err) {
        this.$message.error('Что-то пошло не так')
      }
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    cancelAuthModal() {
      this.resetForm()
      this.$emit('cancel')
    },
    inputNickname() {
      this.$emit('input-nickname')
    }
  }
}
